<script>
  import cursoServico from '~modulos/curso/servico';
  import pagamentoServico from '~modulos/pagamento/servico';
  import ModalMensagem from '~componentes/ModalMensagem.vue';

  export default {
    components: { ModalMensagem },
    data() {
      return {
        animated: true,
        carregando: true,
        configuracao: this.$storage.configuracao(),
        cursos: [],
        filtros: {
          idCurso: '',
          idTurma: '',
          situacao: 'todas',
        },
        linhaParaPagar: null,
        gerandoBoleto: false,
        modalMensagem: false,
        linhaParaMensagem: null,
        verificandoPagamento: false,
        idLancamentoVerificar: null,
        tmrVerificacao: null,
        tentativasVerificacao: 0,
      }
    },
    computed: {
      fupef() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUPEF';
      },
      hojeMs() {
        const h = new Date();
        return new Date(h.getFullYear(), h.getMonth(), h.getDate()).getTime();
      },
      ultimoDiaMesAtualMs() {
        const h = new Date();
        return new Date(h.getFullYear(), h.getMonth() + 1, 0).getTime();
      },
      cursosDisponiveis() {
        const mapa = new Map();
        for (const curso of this.cursos) {
          if (!mapa.has(curso.idCurso)) {
            mapa.set(curso.idCurso, { id: curso.idCurso, nome: curso.descricaoCurso });
          }
        }
        return Array.from(mapa.values()).sort((a, b) => a.nome.localeCompare(b.nome));
      },
      turmasDisponiveis() {
        const filtradas = this.filtros.idCurso
          ? this.cursos.filter(c => String(c.idCurso) === String(this.filtros.idCurso))
          : this.cursos;

        const mapa = new Map();
        for (const curso of filtradas) {
          if (!mapa.has(curso.idReferencia)) {
            mapa.set(curso.idReferencia, { id: curso.idReferencia, nome: curso.nomeTurma });
          }
        }
        return Array.from(mapa.values()).sort((a, b) => a.nome.localeCompare(b.nome));
      },
      resumo() {
        let qtdVencidas = 0;
        let qtdAVencer = 0;
        let valorTotal = 0;

        for (const curso of this.cursos) {
          for (const lancamento of (curso.lancamentos || [])) {
            const pago = (lancamento.data || 0) > 10;
            const cancelado = (lancamento.dataCancelamento || 0) > 10;
            if (pago || cancelado) continue;

            const vencimentoMs = this.delphiDateParaMs(lancamento.dataVencimento);
            const total = (lancamento.valorReceberPagar || 0)
                        + (lancamento.juros || 0)
                        + (lancamento.multa || 0)
                        - (lancamento.desconto || 0);

            valorTotal += total;
            if (vencimentoMs !== null && vencimentoMs < this.hojeMs) qtdVencidas++;
            else qtdAVencer++;
          }
        }

        return {
          qtdVencidas,
          qtdAVencer,
          qtdTotal: qtdVencidas + qtdAVencer,
          valorTotal,
        };
      },
      linhas() {
        const pendentes = [];
        const historico = [];

        for (const curso of this.cursos) {
          if (this.filtros.idCurso && String(curso.idCurso) !== String(this.filtros.idCurso)) continue;
          if (this.filtros.idTurma && String(curso.idReferencia) !== String(this.filtros.idTurma)) continue;

          for (const lancamento of (curso.lancamentos || [])) {
            const pago = (lancamento.data || 0) > 10;
            const cancelado = (lancamento.dataCancelamento || 0) > 10;
            const vencimentoMs = this.delphiDateParaMs(lancamento.dataVencimento);

            let situacao;
            if (cancelado) situacao = 'cancelada';
            else if (pago) situacao = 'paga';
            else if (vencimentoMs !== null && vencimentoMs < this.hojeMs) situacao = 'vencida';
            else situacao = 'aVencer';

            const emAbertoNoMes = !pago && !cancelado
              && vencimentoMs !== null
              && vencimentoMs <= this.ultimoDiaMesAtualMs;

            if (this.filtros.situacao === 'pagas' && !pago) continue;
            if (this.filtros.situacao === 'em-aberto' && !emAbertoNoMes) continue;
            if (this.filtros.situacao === 'canceladas' && !cancelado) continue;

            const total = (lancamento.valorReceberPagar || 0)
                        + (lancamento.juros || 0)
                        + (lancamento.multa || 0)
                        - (lancamento.desconto || 0);

            const ehPendente = situacao === 'vencida' || situacao === 'aVencer';
            const destino = ehPendente ? pendentes : historico;

            destino.push({ curso, lancamento, pago, cancelado, situacao, total });
          }
        }

        const prioridade = {
          'vencida':   1,
          'aVencer':   2,
          'paga':      3,
          'cancelada': 4,
        };

        const ordenar = (arr) => arr.sort((a, b) => {
          const dp = prioridade[a.situacao] - prioridade[b.situacao];
          if (dp !== 0) return dp;
          const dc = String(a.curso.descricaoCurso || '').localeCompare(b.curso.descricaoCurso || '');
          if (dc !== 0) return dc;
          const dt = String(a.curso.nomeTurma || '').localeCompare(b.curso.nomeTurma || '');
          if (dt !== 0) return dt;
          return (a.lancamento.dataVencimento || 0) - (b.lancamento.dataVencimento || 0);
        });

        return { pendentes: ordenar(pendentes), historico: ordenar(historico) };
      },
      linhasComCabecalhos() {
        const itens = [];
        const { pendentes, historico } = this.linhas;

        const emitirSecao = (label, classe, lista) => {
          if (!lista.length) return;
          itens.push({ tipo: 'cabecalho', label, classe });

          let cursoAtual = null;
          let turmaAtual = null;
          for (const linha of lista) {
            const mudouCurso = linha.curso.idCurso !== cursoAtual;
            const mudouTurma = mudouCurso || linha.curso.idReferencia !== turmaAtual;
            if (mudouCurso || mudouTurma) {
              itens.push({
                tipo: 'subcabecalho',
                descricaoCurso: linha.curso.descricaoCurso,
                nomeTurma: linha.curso.nomeTurma,
              });
              cursoAtual = linha.curso.idCurso;
              turmaAtual = linha.curso.idReferencia;
            }
            itens.push({ tipo: 'linha', linha });
          }
        };

        emitirSecao('PENDÊNCIAS', 'cabecalho-pendencias', pendentes);
        emitirSecao('HISTÓRICO', 'cabecalho-historico', historico);

        return itens;
      },
      totalLinhas() {
        return this.linhas.pendentes.length + this.linhas.historico.length;
      },
    },
    methods: {
      listar() {
        this.carregando = true;

        return cursoServico
          .lista(true, true)
          .then(cursos => {
            this.cursos = cursos;
            this.carregando = false;
          })
          .catch(erro => {
            this.carregando = false;
            this.$mensagemErro(erro, 'Erro ao carregar contas a receber.');
          });
      },
      iniciarVerificacaoPagamento(idLancamento) {
        this.idLancamentoVerificar = parseInt(idLancamento, 10);
        this.tentativasVerificacao = 0;
        this.verificandoPagamento = true;

        if (this.lancamentoEstaPago(this.idLancamentoVerificar)) {
          this.pararVerificacao(true);
          return;
        }

        this.tmrVerificacao = setInterval(() => {
          this.tentativasVerificacao++;

          this.listar().then(() => {
            if (this.lancamentoEstaPago(this.idLancamentoVerificar)) {
              this.pararVerificacao(true);
            } else if (this.tentativasVerificacao >= 12) {
              this.pararVerificacao(false);
            }
          });
        }, 5000);
      },
      lancamentoEstaPago(idLancamento) {
        for (const curso of this.cursos) {
          for (const lancamento of (curso.lancamentos || [])) {
            if (lancamento.idLancamento === idLancamento)
              return (lancamento.data || 0) > 10;
          }
        }
        return false;
      },
      pararVerificacao(pago) {
        if (this.tmrVerificacao) {
          clearInterval(this.tmrVerificacao);
          this.tmrVerificacao = null;
        }
        this.verificandoPagamento = false;
        if (pago) this.$swal('', 'Pagamento confirmado!', 'success');
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      onCursoChange() {
        this.filtros.idTurma = '';
      },
      delphiDateParaMs(delphiDate) {
        if (!delphiDate || delphiDate <= 10) return null;
        const epoch = new Date(1899, 11, 30);
        return new Date(epoch.getFullYear(), epoch.getMonth(), epoch.getDate() + delphiDate).getTime();
      },
      parcelaPagavel(linha) {
        if (linha.pago || linha.cancelado) return false;
        const vencimentoMs = this.delphiDateParaMs(linha.lancamento.dataVencimento);
        return vencimentoMs !== null && vencimentoMs <= this.ultimoDiaMesAtualMs;
      },
      boletoAntecipado(linha) {
        if (linha.pago || linha.cancelado) return false;
        if (linha.situacao === 'vencida') return false;
        if ((linha.lancamento.idComplemento || 0) <= 0) return false;
        return !this.parcelaPagavel(linha);
      },
      boletoIndisponivelNoMes(linha) {
        if (linha.situacao !== 'aVencer') return false;
        if ((linha.lancamento.idComplemento || 0) > 0) return false;
        return !this.parcelaPagavel(linha);
      },
      mesDisponibilidadeBoleto(linha) {
        const vencimentoMs = this.delphiDateParaMs(linha.lancamento.dataVencimento);
        if (vencimentoMs === null) return '';
        const data = new Date(vencimentoMs);
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        return `${mes}/${data.getFullYear()}`;
      },
      classeLinha(situacao) {
        return {
          'paga':      'success',
          'cancelada': 'linha-cancelada',
          'vencida':   'danger',
          'aVencer':   'warning',
        }[situacao] || '';
      },
      classeBadge(situacao) {
        return {
          'paga':      'label-success',
          'cancelada': 'label-default',
          'vencida':   'label-danger',
          'aVencer':   'label-warning',
        }[situacao] || 'label-default';
      },
      rotuloSituacao(situacao) {
        return {
          'paga':      'Paga',
          'cancelada': 'Cancelada',
          'vencida':   'Vencida',
          'aVencer':   'A vencer',
        }[situacao] || '';
      },
      prefixoVencimento(situacao) {
        return {
          'vencida': 'Venceu em',
          'aVencer': 'Vence em',
        }[situacao] || '';
      },
      formatarParcela(documento) {
        if (!documento) return '---';
        return String(documento).replace(/^-+/, '').trim() || '---';
      },
      formatarNossoNumero(nossoNumero) {
        if (!nossoNumero) return '---';
        return String(nossoNumero).trim() || '---';
      },
      abrirModalPagamento(linha) {
        this.linhaParaPagar = linha;
        this.$nextTick(() => {
          $('#ModalEscolhaPagamento').modal('show');
        });
      },
      mostrarModalMensagem(linha) {
        this.linhaParaMensagem = linha;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.modalMensagem = false;
        this.listar();
      },
      executarOpcao(opcao) {
        const $modal = $('#ModalEscolhaPagamento');
        $modal.one('hidden.bs.modal', () => opcao.acao());
        $modal.modal('hide');
      },
      mensagemDoErro(erro, padrao) {
        if (!erro) return padrao;

        if (erro.status === 0) {
          return 'Não foi possível falar com o servidor. Verifique sua conexão e tente novamente.';
        }

        if (erro.body && erro.body.mensagem) return erro.body.mensagem;

        if (typeof erro.body === 'string' && erro.body.trim()) return erro.body.trim();

        if (erro.bodyText && erro.bodyText.trim()) {
          const texto = erro.bodyText.trim();
          try {
            const json = JSON.parse(texto);
            if (json && json.mensagem) return json.mensagem;
          } catch (e) {
            return texto;
          }
          return texto;
        }

        if (erro.status === 404) {
          return 'Parcela não encontrada. Atualize a lista e tente novamente.';
        }

        if (erro.message) return erro.message;

        return padrao;
      },
      erroPagamento(titulo, erro) {
        const detalhe = this.mensagemDoErro(erro, '');
        const texto = detalhe ? `${titulo}<br>${detalhe}` : titulo;

        if (!erro) {
          this.$swal('', texto, 'error');
          return;
        }

        this.$mensagemErro(erro, texto);
      },
      abrirUrlPagamento(url, titulo) {
        const endereco = String(url || '').trim();

        if (!endereco) {
          this.erroPagamento(titulo, null);
          return false;
        }

        const janela = window.open(endereco);

        if (!janela) {
          this.$swal(
            'Não foi possível abrir a página de pagamento',
            'O navegador bloqueou a abertura de uma nova janela. Libere os pop-ups deste site e tente novamente.',
            'warning'
          );
          return false;
        }

        return true;
      },
      opcoesPagamento(linha) {
        const curso = linha.curso;
        const lancamento = linha.lancamento;
        const opcoes = [];

        const vencida = linha.situacao === 'vencida';
        const boletoRegistrado = (lancamento.idComplemento || 0) > 0;
        const boletoLiberado = !vencida || boletoRegistrado;

        if (curso.estrangeiro == 0) {
          if ((curso.boletoMensalidade || this.visualizaBoleto(linha)) && boletoLiberado) {
            opcoes.push({
              key: 'boleto',
              label: 'Boleto',
              icone: 'fa-print',
              classe: 'btn-primary',
              acao: () => this.imprimir(lancamento.idLancamento),
            });
          }
          if (curso.pagSeguroMensalidade) {
            opcoes.push({
              key: 'pagseguro',
              label: 'PagSeguro',
              icone: 'fa-money',
              classe: 'btn-default',
              acao: () => this.pagarPagSeguroCheckout(lancamento),
            });
          }
          if (curso.getNetBoletoMensalidade) {
            opcoes.push({
              key: 'getnet-boleto',
              label: 'Boleto GetNet',
              icone: 'fa-barcode',
              classe: 'btn-success',
              acao: () => this.pagarBoletoGetNet(lancamento),
            });
          }
          if (curso.getNetCreditoMensalidade) {
            opcoes.push({
              key: 'getnet-credito',
              label: 'Crédito GetNet',
              icone: 'fa-credit-card',
              classe: 'btn-warning',
              acao: () => this.pagarCreditoGetNet(lancamento),
            });
          }
          if (curso.getNetDebitoMensalidade) {
            opcoes.push({
              key: 'getnet-debito',
              label: 'Débito GetNet',
              icone: 'fa-credit-card-alt',
              classe: 'btn-info',
              acao: () => this.pagarDebitoGetNet(lancamento),
            });
          }
        } else if (curso.estrangeiro == 1) {
          if (curso.getNetCreditoEstrangeiroMensalidade) {
            opcoes.push({
              key: 'getnet-credito-int',
              label: 'Crédito GetNet',
              icone: 'fa-credit-card-alt',
              classe: 'btn-warning',
              acao: () => this.pagarCreditoIntGetNet(lancamento),
            });
          }
        }

        if (opcoes.length === 0 && boletoLiberado) {
          opcoes.push({
            key: 'boleto-fallback',
            label: 'Boleto',
            icone: 'fa-print',
            classe: 'btn-primary',
            acao: () => this.imprimir(lancamento.idLancamento),
          });
        }

        return opcoes;
      },
      visualizaBoleto(linha) {
        if (linha.pago) return false;

        if (this.fupef) {
          if (linha.lancamento.qntDiasVencimento > 23) return false;
          return true;
        }

        return !(
          linha.curso.boletoMensalidade ||
          linha.curso.pagSeguroMensalidade ||
          linha.curso.getNetBoletoMensalidade ||
          linha.curso.getNetCreditoMensalidade ||
          linha.curso.getNetDebitoMensalidade
        );
      },
      imprimir(idLancamento) {
        if (this.gerandoBoleto) return;

        this.gerandoBoleto = true;
        $('#ModalPlataformasPgto').modal('show');

        cursoServico
          .boleto(idLancamento)
          .then(boleto => {
            this.gerandoBoleto = false;
            $('#ModalPlataformasPgto').modal('hide');

            const conteudo = String(boleto || '').trim();

            if (!conteudo) {
              this.$swal(
                'Boleto indisponível',
                'O boleto desta parcela não foi retornado pelo banco. Tente novamente mais tarde ou entre em contato com a fundação.',
                'error'
              );
              return;
            }

            const pagina = window.open('about:blank');

            if (!pagina) {
              this.$swal(
                'Não foi possível abrir o boleto',
                'O navegador bloqueou a abertura de uma nova janela. Libere os pop-ups deste site e tente novamente.',
                'warning'
              );
              return;
            }

            try {
              pagina.document.write(conteudo.replace('Boleto.Net', 'Boleto'));

              const marca = pagina.document.getElementsByClassName('w150 cn8 Al Ab')[0];
              if (marca) marca.remove();

              pagina.stop();
            } catch (e) {
              this.$swal('Não foi possível exibir o boleto', this.mensagemDoErro(e, 'Tente novamente mais tarde.'), 'error');
            }
          })
          .catch(erro => {
            this.gerandoBoleto = false;
            $('#ModalPlataformasPgto').modal('hide');

            this.erroPagamento('Não foi possível gerar o boleto', erro);
          });
      },
      pagarPagSeguroCheckout(lancamento) {
        $('#pagSeguroMensalidade').button('loading');
        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarCheckout(lancamento)
          .then(retorno => {
            $('#pagSeguroMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            var url = retorno.bodyText;

            if (!url || !String(url).trim()) {
              this.erroPagamento('Problema no processamento do pagamento pelo PagSeguro', null);
              return;
            }

            window.open(url, '_self');
          })
          .catch(error => {
            $('#pagSeguroMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.erroPagamento('Problema no processamento do pagamento pelo PagSeguro', error);
          });
      },
      pagarBoletoGetNet(lancamento) {
        $('#getNetBoletoMensalidade').button('loading');
        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarBoletoGetNet(lancamento)
          .then(retorno => {
            $('#getNetBoletoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            if (!this.abrirUrlPagamento(retorno.bodyText, 'Problema no processamento do pagamento pelo boleto GetNet')) return;

            this.listar();
          })
          .catch(error => {
            $('#getNetBoletoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.erroPagamento('Problema no processamento do pagamento pelo boleto GetNet', error);
          });
      },
      pagarCreditoGetNet(lancamento) {
        $('#getNetCreditoMensalidade').button('loading');
        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarCreditoGetNet(lancamento)
          .then(retorno => {
            $('#getNetCreditoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.abrirUrlPagamento(retorno.bodyText, 'Problema no processamento do pagamento pelo crédito GetNet');
          })
          .catch(error => {
            $('#getNetCreditoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.erroPagamento('Problema no processamento do pagamento pelo crédito GetNet', error);
          });
      },
      pagarDebitoGetNet(lancamento) {
        $('#getNetDebitoMensalidade').button('loading');
        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarDebitoGetNet(lancamento)
          .then(retorno => {
            $('#getNetDebitoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.abrirUrlPagamento(retorno.bodyText, 'Problema no processamento do pagamento pelo débito GetNet');
          })
          .catch(error => {
            $('#getNetDebitoMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.erroPagamento('Problema no processamento do pagamento pelo débito GetNet', error);
          });
      },
      pagarCreditoIntGetNet(lancamento) {
        $('#getNetCreditoEstrangeiroMensalidade').button('loading');
        $('#ModalPlataformasPgto').modal('show');

        pagamentoServico
          .pagarCreditoGetNet(lancamento)
          .then(retorno => {
            $('#getNetCreditoEstrangeiroMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.abrirUrlPagamento(retorno.bodyText, 'Problema no processamento do pagamento pelo crédito internacional GetNet');
          })
          .catch(error => {
            $('#getNetCreditoEstrangeiroMensalidade').button('reset');
            $('#ModalPlataformasPgto').modal('hide');

            this.erroPagamento('Problema no processamento do pagamento pelo crédito internacional GetNet', error);
          });
      },
    },
    created() {
      this.listar().then(() => {
        if (this.$route.query.pago) this.iniciarVerificacaoPagamento(this.$route.query.pago);
      });
    },
    mounted() {
      this.$root.tituloDaPagina = 'Mensalidades';
      this.$root.botaoAcaoMostrar = false;
      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('recarregarCursos', this.listar);
    },
    beforeDestroy() {
      this.$events.off('recarregarCursos');
      if (this.tmrVerificacao) clearInterval(this.tmrVerificacao);
    },
  }
</script>

<style scoped>
  .btn-pagar {
    font-size: 0.9em;
    padding: 6px 14px;
    min-width: 130px;
  }

  .icone-boleto, .icone-boleto-fallback { color: #337ab7; }
  .icone-pagseguro                       { color: #00a4e0; }
  .icone-getnet-boleto                   { color: #5cb85c; }
  .icone-getnet-credito                  { color: #f0ad4e; }
  .icone-getnet-debito                   { color: #5bc0de; }
  .icone-getnet-credito-int              { color: #f0ad4e; }

  .resumo-pagamento {
    padding: 18px 22px;
    background-color: #f9f9f9;
    border-radius: 4px;
    margin-bottom: 18px;
  }
  .resumo-curso {
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 4px;
    text-align: center;
  }
  .resumo-linha {
    font-size: 0.9em;
    color: #666;
    margin-bottom: 14px;
    text-align: center;
  }
  .resumo-sep {
    color: #ccc;
    margin: 0 6px;
  }
  .breakdown-pagamento {
    width: 100%;
    margin-bottom: 12px;
  }
  .breakdown-pagamento td {
    padding: 4px 0;
    font-size: 0.95em;
  }
  .breakdown-label {
    color: #555;
  }
  .breakdown-valor {
    text-align: right;
    font-weight: 600;
    color: #333;
    font-variant-numeric: tabular-nums;
  }
  .breakdown-desconto {
    color: #3c763d;
  }
  .breakdown-total {
    border-top: 1px solid #ddd;
    padding-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .breakdown-total-label {
    font-weight: 700;
    color: #2c3e50;
    font-size: 1.05em;
  }
  .resumo-total {
    font-size: 1.6em;
    font-weight: 700;
    color: #2c3e50;
  }

  .opcoes-pagamento {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .opcao-pagamento {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    transition: all 0.15s ease;
    text-align: left;
    width: 100%;
    margin-bottom: 8px;
  }
  .opcao-pagamento:hover {
    border-color: #337ab7;
    background-color: #f5f9fc;
  }
  .opcao-pagamento > .fa-2x {
    width: 40px;
    text-align: center;
  }
  .opcao-label {
    flex: 1;
    margin-left: 14px;
    font-size: 1.05em;
    font-weight: 600;
    color: #333;
  }
  .opcao-seta {
    color: #ccc;
  }
  .opcao-pagamento:hover .opcao-seta {
    color: #337ab7;
  }

  .radio-situacao {
    margin-right: 15px;
    cursor: pointer;
  }

  .label {
    font-size: 0.85em;
    padding: 4px 8px;
    display: inline-block;
    min-width: 70px;
  }

  .total-pagar {
    font-weight: 700;
    font-size: 1.3em;
    color: #2c3e50;
    white-space: nowrap;
  }
  tr.danger .total-pagar {
    color: #a94442;
  }
  tr.warning .total-pagar {
    color: #8a6d3b;
  }
  tr.success .total-pagar {
    color: #3c763d;
  }

  .linha-separador-secao > td {
    font-size: 0.9em;
    font-weight: 700;
    letter-spacing: 1.5px;
    padding: 12px 15px;
    background-color: #f5f5f5;
    border-top: 2px solid #ccc;
    color: #555;
  }
  .linha-separador-secao.cabecalho-pendencias > td {
    background-color: #fdf2f0;
    color: #8a3a3a;
    border-top-color: #d9534f;
  }
  .linha-separador-secao.cabecalho-historico > td {
    background-color: #f7f7f7;
    color: #777;
  }

  .linha-subcabecalho > td {
    background-color: #fff;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    padding: 8px 15px;
  }
  .subcab-curso {
    font-weight: 700;
    color: #2c3e50;
    font-size: 0.95em;
  }
  .subcab-sep {
    color: #ccc;
    margin: 0 8px;
  }
  .subcab-turma {
    color: #666;
    font-size: 0.9em;
  }

  .prefixo-rs {
    font-weight: 700;
    margin-right: 3px;
  }
  .painel-rs {
    font-weight: 700;
    margin-right: 5px;
  }
  .painel-detalhe {
    font-size: 0.9em;
    opacity: 0.85;
    margin-top: 4px;
    margin-left: 22px;
  }

  .coluna-curso,
  .coluna-turma {
    font-weight: 600;
  }

  .linha-novo-grupo > td {
    border-top: 2px solid #d1d5db;
  }

  .linha-cancelada > td {
    background-color: #fff !important;
    color: #999;
    opacity: 0.6;
  }
  .linha-cancelada .total-pagar {
    color: #999;
  }

  .painel-resumo {
    padding: 18px 22px;
    border-radius: 4px;
    margin-bottom: 15px;
    border-left: 5px solid;
  }
  .painel-vencidas {
    background-color: #fdecea;
    border-left-color: #d9534f;
    color: #6b1f1c;
  }
  .painel-pendentes {
    background-color: #fcf8e3;
    border-left-color: #f0ad4e;
    color: #7a5a1b;
  }
  .painel-em-dia {
    background-color: #dff0d8;
    border-left-color: #5cb85c;
    color: #2b542c;
  }
  .painel-titulo {
    font-size: 1.05em;
    line-height: 1.6em;
  }
  .painel-subtitulo {
    font-size: 0.85em;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    opacity: 0.8;
  }
  .painel-valor {
    font-size: 1.8em;
    font-weight: 700;
    line-height: 1.2em;
  }

  .coluna-parcela {
    font-weight: 600;
    white-space: nowrap;
  }

  .coluna-nosso-numero {
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
</style>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <div class="modal fade" id="ModalPlataformasPgto" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p>
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span style="font-size: 16px;margin-left: 10px;">Entrando em contato com o provedor. Aguarde...</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="ModalEscolhaPagamento" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document" v-if="linhaParaPagar">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Escolha a forma de pagamento</h4>
          </div>
          <div class="modal-body">
            <div class="resumo-pagamento">
              <div class="resumo-curso">{{ linhaParaPagar.curso.descricaoCurso }}</div>
              <div class="resumo-linha">
                <span class="resumo-parcela">Parcela {{ formatarParcela(linhaParaPagar.lancamento.documento) }}</span>
                <span class="resumo-sep">·</span>
                <span class="resumo-vencimento">
                  {{ prefixoVencimento(linhaParaPagar.situacao) }}
                  {{ linhaParaPagar.lancamento.dataVencimento | formatarNumeroEmData }}
                </span>
              </div>

              <table class="breakdown-pagamento">
                <tr>
                  <td class="breakdown-label">Valor original</td>
                  <td class="breakdown-valor"><span class="prefixo-rs">R$</span> {{ linhaParaPagar.lancamento.valorReceberPagar | formatarNumero }}</td>
                </tr>
                <tr v-if="linhaParaPagar.lancamento.juros">
                  <td class="breakdown-label">Juros</td>
                  <td class="breakdown-valor"><span class="prefixo-rs">R$</span> {{ linhaParaPagar.lancamento.juros | formatarNumero }}</td>
                </tr>
                <tr v-if="linhaParaPagar.lancamento.multa">
                  <td class="breakdown-label">Multa</td>
                  <td class="breakdown-valor"><span class="prefixo-rs">R$</span> {{ linhaParaPagar.lancamento.multa | formatarNumero }}</td>
                </tr>
                <tr v-if="linhaParaPagar.lancamento.desconto">
                  <td class="breakdown-label breakdown-desconto">Desconto</td>
                  <td class="breakdown-valor breakdown-desconto">− <span class="prefixo-rs">R$</span> {{ linhaParaPagar.lancamento.desconto | formatarNumero }}</td>
                </tr>
              </table>

              <div class="breakdown-total">
                <div class="breakdown-total-label">Total atualizado</div>
                <div class="resumo-total">
                  <span class="prefixo-rs">R$</span>
                  {{ linhaParaPagar.total | formatarNumero }}
                </div>
              </div>
            </div>

            <div class="opcoes-pagamento">
              <button v-for="opcao in opcoesPagamento(linhaParaPagar)"
                      :key="opcao.key"
                      type="button"
                      class="opcao-pagamento"
                      @click="executarOpcao(opcao)">
                <i class="fa fa-2x" :class="[opcao.icone, 'icone-' + opcao.key]"></i>
                <span class="opcao-label">{{ opcao.label }}</span>
                <i class="fa fa-chevron-right opcao-seta"></i>
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancelar</button>
          </div>
        </div>
      </div>
    </div>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="linhaParaMensagem ? linhaParaMensagem.lancamento.idPessoaCript : ''"
                    :numero="linhaParaMensagem ? linhaParaMensagem.lancamento.historico : ''"
                    tipo="MensalidadePessoaFisica"
                    @fechado="modalMensagensFechado"></modal-mensagem>

    <div class="row" v-if="verificandoPagamento">
      <div class="col-lg-12">
        <div class="alert alert-info">
          <i class="fa fa-spinner fa-pulse"></i>
          Verificando pagamento... A lista é atualizada automaticamente assim que o pagamento for confirmado.
        </div>
      </div>
    </div>

    <div class="row" v-if="!carregando">
      <div class="col-lg-12">
        <div :class="['painel-resumo', resumo.qtdVencidas > 0 ? 'painel-vencidas' : (resumo.qtdTotal > 0 ? 'painel-pendentes' : 'painel-em-dia')]">
          <div class="row" v-if="resumo.qtdTotal > 0">
            <div class="col-sm-7">
              <div class="painel-titulo" v-if="resumo.qtdVencidas > 0">
                <i class="fa fa-exclamation-triangle"></i>
                Você possui <strong>{{ resumo.qtdVencidas }}</strong>
                {{ resumo.qtdVencidas === 1 ? 'parcela vencida' : 'parcelas vencidas' }}
              </div>
              <div class="painel-titulo" v-else>
                <i class="fa fa-clock-o"></i>
                Você possui <strong>{{ resumo.qtdTotal }}</strong>
                {{ resumo.qtdTotal === 1 ? 'parcela a vencer' : 'parcelas a vencer' }}
              </div>
              <div class="painel-detalhe" v-if="resumo.qtdVencidas > 0 && resumo.qtdAVencer > 0">
                e mais {{ resumo.qtdAVencer }} {{ resumo.qtdAVencer === 1 ? 'parcela a vencer' : 'parcelas a vencer' }}
              </div>
            </div>
            <div class="col-sm-5 text-right">
              <div class="painel-subtitulo">Total atualizado</div>
              <div class="painel-valor">
                <span class="painel-rs">R$</span>
                {{ resumo.valorTotal | formatarNumero }}
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-xs-12">
              <div class="painel-titulo">
                <i class="fa fa-check-circle"></i>
                Você está em dia. Nenhuma parcela pendente.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>

          <div class="ibox-content">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="control-label" for="curso">Curso</label>
                  <select id="curso"
                          class="form-control"
                          v-model="filtros.idCurso"
                          @change="onCursoChange">
                    <option value="">Todos</option>
                    <option :value="c.id" v-for="c in cursosDisponiveis" :key="c.id">{{ c.nome }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label class="control-label" for="turma">Turma</label>
                  <select id="turma"
                          class="form-control"
                          v-model="filtros.idTurma">
                    <option value="">Todas</option>
                    <option :value="t.id" v-for="t in turmasDisponiveis" :key="t.id">{{ t.nome }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label class="control-label">Situação</label>
                  <div>
                    <label class="radio-situacao">
                      <input type="radio" v-model="filtros.situacao" value="todas"> Todas
                    </label>
                    <label class="radio-situacao">
                      <input type="radio" v-model="filtros.situacao" value="em-aberto"> Em aberto
                    </label>
                    <label class="radio-situacao">
                      <input type="radio" v-model="filtros.situacao" value="pagas"> Pagas
                    </label>
                    <label class="radio-situacao">
                      <input type="radio" v-model="filtros.situacao" value="canceladas"> Canceladas
                    </label>
                    <button type="button" class="btn btn-primary btn-sm" @click="listar" :disabled="carregando">
                      <i class="fa fa-refresh" :class="{ 'fa-spin': carregando }"></i> Atualizar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">
            <div class="alert alert-info" role="alert" v-if="fupef">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group no-margins">
                    <dl class="col-xs-12">
                      <dt>Observação</dt>
                      <dd>
                        Para mensalidades vencidas, consulte a fundação.
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Situação</th>
                    <th class="text-center">Parcela</th>
                    <th class="text-center">Nosso número</th>
                    <th>Vencimento</th>
                    <th class="text-center">Valor</th>
                    <th class="text-center">Juros</th>
                    <th class="text-center">Multa</th>
                    <th class="text-center">Desconto</th>
                    <th class="text-right">Total a pagar</th>
                    <th class="text-center">Valor pago</th>
                    <th class="text-center">Meio de pagamento</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, idx) in linhasComCabecalhos">
                    <tr v-if="item.tipo === 'cabecalho'"
                        :key="'h-' + idx"
                        :class="['linha-separador-secao', item.classe]">
                      <td colspan="11">{{ item.label }}</td>
                    </tr>
                    <tr v-else-if="item.tipo === 'subcabecalho'"
                        :key="'s-' + idx"
                        class="linha-subcabecalho">
                      <td colspan="11">
                        <span class="subcab-curso">{{ item.descricaoCurso }}</span>
                        <span class="subcab-sep">·</span>
                        <span class="subcab-turma">{{ item.nomeTurma }}</span>
                      </td>
                    </tr>
                    <tr v-else
                        :key="item.linha.lancamento.idLancamento"
                        :class="classeLinha(item.linha.situacao)">
                      <td class="text-center">
                        <span class="label" :class="classeBadge(item.linha.situacao)">
                          {{ rotuloSituacao(item.linha.situacao) }}
                        </span>
                      </td>
                      <td class="text-center coluna-parcela">{{ formatarParcela(item.linha.lancamento.documento) }}</td>
                      <td class="text-center coluna-nosso-numero">{{ formatarNossoNumero(item.linha.lancamento.nossoNumero) }}</td>
                      <td>
                        <small class="text-muted" v-if="prefixoVencimento(item.linha.situacao)">
                          {{ prefixoVencimento(item.linha.situacao) }}
                        </small>
                        {{ item.linha.lancamento.dataVencimento | formatarNumeroEmData }}
                      </td>
                      <td class="text-center">{{ item.linha.lancamento.valorReceberPagar | formatarNumero }}</td>
                      <td class="text-center">{{ item.linha.lancamento.juros | formatarNumero }}</td>
                      <td class="text-center">{{ item.linha.lancamento.multa | formatarNumero }}</td>
                      <td class="text-center">{{ item.linha.lancamento.desconto | formatarNumero }}</td>
                      <td class="text-right total-pagar">
                        <span class="prefixo-rs">R$</span>
                        {{ item.linha.total | formatarNumero }}
                      </td>
                      <td class="text-center">{{ item.linha.lancamento.valor | formatarNumero }}</td>
                      <td class="text-center">
                        <button v-if="item.linha.situacao === 'vencida' && (!item.linha.lancamento.permiteBoletoVencido || opcoesPagamento(item.linha).length === 0)"
                                type="button"
                                class="btn btn-success btn-pagar"
                                title="Conversar sobre esta parcela"
                                @click="mostrarModalMensagem(item.linha)">
                          <i class="fa fa-comment"></i>
                          Conversar
                        </button>

                        <template v-else-if="parcelaPagavel(item.linha)">
                          <button v-if="opcoesPagamento(item.linha).length === 1"
                                  type="button"
                                  class="btn btn-primary btn-pagar"
                                  @click="opcoesPagamento(item.linha)[0].acao()">
                            <i class="fa" :class="opcoesPagamento(item.linha)[0].icone"></i>
                            {{ opcoesPagamento(item.linha)[0].label }}
                          </button>

                          <button v-else
                                  type="button"
                                  class="btn btn-primary btn-pagar"
                                  @click="abrirModalPagamento(item.linha)">
                            <i class="fa fa-credit-card"></i>
                            Pagar
                          </button>
                        </template>

                        <button v-else-if="boletoAntecipado(item.linha)"
                                type="button"
                                class="btn btn-primary btn-pagar"
                                @click="imprimir(item.linha.lancamento.idLancamento)">
                          <i class="fa fa-print"></i>
                          Boleto
                        </button>

                        <small v-else-if="boletoIndisponivelNoMes(item.linha)" class="text-muted">
                          Disponível para pgto a partir de {{ mesDisponibilidadeBoleto(item.linha) }}
                        </small>
                      </td>
                    </tr>
                  </template>
                  <tr v-show="carregando">
                    <td colspan="11">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                  <tr v-show="!carregando && totalLinhas === 0">
                    <td colspan="11" class="text-center text-muted">
                      Nenhuma mensalidade encontrada.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/MensalidadesLista.vue